"use strict";
/**
 *  Export all the shared frontend utils.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFormatter = exports.LocalStorageStore = void 0;
// Local storage
var store_1 = __importDefault(require("./localStorage/store"));
exports.LocalStorageStore = store_1.default;
// Currency
var currency_1 = require("./currency");
Object.defineProperty(exports, "CurrencyFormatter", { enumerable: true, get: function () { return currency_1.CurrencyFormatter; } });
//# sourceMappingURL=index.js.map